export default [
  {
    path: '/',
    name: 'Home',
    meta: { layout: 'side-nav' },
    component: r => require(['@/pages/index'], r)
  },
  {
    path: '/rag',
    component: { render: h => h('router-view') },
    children: [
      {
        path: '',
        name: 'RAG',
        meta: { layout: 'side-nav' },
        component: r => require(['@/pages/rag/index'], r)
      }
    ]
  },
  {
    path: '/servicerequests/:status',
    component: { render: h => h('router-view') },
    children: [
      {
        path: '',
        name: 'Service Requests',
        meta: { layout: 'side-nav' },
        component: r => require(['@/pages/servicerequests/index'], r)
      }
    ]
  },
  {
    path: '/servicerequest/:id',
    component: { render: h => h('router-view') },
    children: [
      {
        path: '',
        name: 'Service Request',
        meta: { layout: 'side-nav' },
        component: r => require(['@/pages/servicerequests/upsert'], r)
      }
    ]
  },
  {
    path: '/calibration/:id',
    component: { render: h => h('router-view') },
    children: [
      {
        path: '',
        name: 'Calibration',
        meta: { layout: 'side-nav' },
        component(r) {
          require(['@/pages/calibration/index'], r)
        }
      }
    ]
  },
  {
    path: '/processcalibration/:id',
    component: { render: h => h('router-view') },
    children: [
      {
        path: '',
        name: 'Process Calibration',
        meta: { layout: 'side-nav' },
        component(r) {
          require(['@/pages/calibration/process'], r)
        }
      }
    ]
  },
  {
    path: '/chats',
    component: { render: h => h('router-view') },
    children: [
      {
        path: '',
        name: 'Chats',
        meta: { layout: 'side-nav' },
        component(r) {
          require(['@/pages/chat/index'], r)
        }
      }
    ]
  },
  {
    path: '/location',
    component: { render: h => h('router-view') },
    children: [
      {
        path: '',
        name: 'Location',
        meta: { layout: 'side-nav' },
        component(r) {
          require(['@/pages/location/index'], r)
        }
      }
    ]
  },
  {
    path: '/user',
    component: { render: h => h('router-view') },
    children: [
      {
        path: '',
        name: 'User Profile',
        meta: { layout: 'logo-only' },
        component(r) {
          require(['@/pages/user/index'], r)
        }
      }
    ]
  },
  {
    path: '/scanpro',
    component: { render: h => h('router-view') },
    children: [
      {
        path: '',
        name: 'ScanPro Assist',
        meta: { layout: 'side-nav', conditionalRoute: true },
        component(r) {
          require(['@/pages/scanpro/index'], r)
        }
      }
    ]
  },
  {
    path: '/about',
    component: { render: h => h('router-view') },
    children: [
      {
        path: '',
        name: 'About',
        meta: { layout: 'side-nav' },
        component(r) {
          require(['@/pages/about/index'], r)
        }
      }
    ]
  },
  {
    path: '/login',
    name: 'Login',
    meta: { allowAnonymous: true },
    component: r => require(['@/pages/login/index'], r)
  },
  {
    path: '*',
    name: 'Page not Found',
    component: r => require(['@/pages/errors/error-404'], r)
  }
]



// WEBPACK FOOTER //
// ./src/router/routes.js